import React, { useState } from "react";
import { useAuth } from "./AuthContext";
import RegisterPage from "./RegisterPage";
import { useNavigate } from "react-router-dom";

const LoginPage = ({ onLoginSuccess }) => {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [showRegister, setShowRegister] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await login(email, password);

      // ✅ Salva email per OneSignal
      localStorage.setItem("userEmail", email);

      // ✅ Naviga alla dashboard
      navigate("/");
    } catch (err) {
      console.error("Login fallito:", err);
      setError("Credenziali non valide");
    }
  };

  if (showRegister) {
    return (
      <RegisterPage
        onRegisterSuccess={() => setShowRegister(false)}
        onSwitchToLogin={() => setShowRegister(false)}
      />
    );
  }

  return (
    <div className="min-h-screen flex justify-center items-center">
      <form onSubmit={handleSubmit} className="bg-white p-6 rounded shadow w-80">
        <h2 className="text-xl font-bold mb-4">Login</h2>
        {error && <p className="text-red-600">{error}</p>}
        <input
          className="w-full p-2 border mb-2 rounded"
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <input
          className="w-full p-2 border mb-4 rounded"
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        <button className="w-full bg-blue-500 text-white py-2 rounded hover:bg-blue-600">
          Accedi
        </button>
        
      </form>
    </div>
  );
};

export default LoginPage;
